import type { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Text } from '../../../../ui-components';
import { classNames } from '../../../../utils/tailwind/classNames';

interface CategorySearchNoResultProps {
    className?: string;
}

export const CategorySearchNoResult: FC<CategorySearchNoResultProps> = ({ className }) => (
    <div
        className={classNames(
            'flex w-full flex-col items-center justify-center self-stretch px-4 pt-8 sm:px-8 lg:pt-6 pb-16',
            className,
        )}
        data-testid="category-search-no-result"
    >
        <Text color="slt-pepper.1000" align="center">
            <FormattedMessage
                id="category-search.no-results.no-match"
                defaultMessage="No results match your selected filters. "
            />
        </Text>
        <Text color="slt-pepper.1000" align="center">
            <FormattedMessage
                id="category-search.no-results.change-filters"
                defaultMessage="Please remove or change your filters, to see more results."
            />
        </Text>
    </div>
);

CategorySearchNoResult.defaultProps = {
    className: undefined,
};
